module.exports = __webpack_public_path__ + "static/media/bird-blue-jay1.f289bc89.aac";